<template>
    <side-form ref="sideform" v-on:sideform-content-loaded="onFormLoadedEvent" />
</template>

<script>
import SideForm from './SideForm.vue'
import EventBus from '../../EventBus.vue'

export default {


    /* Settings
    --------------------------------------------------------- */

    name: 'CartSideForm',

    components: {
        SideForm,
    },

    props: {
    },

    data() {
        return {
        }
    },


    /* Life Cycle
    --------------------------------------------------------- */

    created() {
        //
    },


    mounted() {
        //
    },


    /* Data Handling
    --------------------------------------------------------- */


    computed: {
    },


    watch: {
        //
    },


    /* Methods
    --------------------------------------------------------- */

    methods: {
        openCreate(productId) {
            this.$refs.sideform.openSideForm()
            this.$refs.sideform.loadHtml(`/cart/create?product=${productId}`)
        },

        openEdit(id) {
            this.$refs.sideform.openSideForm()
            this.$refs.sideform.loadHtml(`/cart/${id}/edit`)
        },

        onFormLoadedEvent() {
            const form = this.$el.querySelector('form')
            if (form) {
                form.addEventListener('submit', (e) => {
                    e.preventDefault()
                    this.sendForm(e.currentTarget)
                })
            }
        },

        sendForm(form) {
            this.$refs.sideform.setLoading(true)

            // clear errors
            const errorMessageElements = this.$el.querySelectorAll('.formError[data-errorkey]')
            const errorFieldElements = this.$el.querySelectorAll('.formInput[data-errorkey]')
            errorMessageElements.forEach((el) => {
                el.innerHTML = ''
            })
            errorFieldElements.forEach((el) => {
                el.classList.remove('has-error')
            })

            const url = form.getAttribute('action')

            const h = new Headers()
            h.append('X-Requested-With', 'XMLHttpRequest')
            h.append('Accept', 'application/json')

            const formData = new FormData(form)

            const fetchOptions = {
                headers     : h,
                method      : 'POST',
                credentials : 'same-origin',
                body        : formData,
            }

            fetch(url, fetchOptions)
                .then((r) => {
                    if (r.status !== 200 && r.status !== 422) {
                        throw Error(r)
                    }

                    return r.json()
                })
                .then((json) => {
                    if (Object.prototype.hasOwnProperty.call(json, 'errors')) {
                        Object.entries(json.errors).forEach(([errorKey, errorValues]) => {
                            const errorMessageElement = this.$el.querySelector(`.formError[data-errorkey="${errorKey}"]`)
                            const errorFieldElement = this.$el.querySelector(`.formInput[data-errorkey="${errorKey}"]`)
                            if (errorMessageElement) {
                                errorMessageElement.innerHTML = errorValues.join('<br>')
                            }
                            if (errorFieldElement) {
                                errorFieldElement.classList.add('has-error')
                            }
                        })
                    } else {
                        EventBus.$emit('cart-update', json)
                        this.$refs.sideform.close()
                    }

                    this.$refs.sideform.setLoading(false)
                })
                .catch((error) => {
                    window.location.reload()
                })
        },
    },


    /* Handlers
    --------------------------------------------------------- */


}

</script>
